import type { DomainCode } from "@/constants/domains";

export function makeEntryCode(domainCode: DomainCode, subdomainCode: string, goalCode: string): string {
  return `${domainCode}-${subdomainCode}-${goalCode}`;
}
